export const DownloadIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L11.2922 15.7064C11.6767 16.0918 12.3236 16.0915 12.7078 15.7064L17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289C17.3166 8.90237 16.6834 8.90237 16.2929 9.29289L13 12.5858V3Z"
        fill="currentColor"
      />
      <path
        d="M2 21C2 20.4477 2.44771 20 2.99999 20L21 20C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22L3.00001 22C2.44772 22 2 21.5523 2 21Z"
        fill="currentColor"
      />
    </svg>
  );
};
